// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";

function DriverBasicInfoCmp$BasicInfoHeaderCmp(Props) {
  var img_path = Props.img_path;
  var header_text = Props.header_text;
  return React.createElement("div", {
              className: "title"
            }, React.createElement("img", {
                  src: img_path
                }), React.createElement("div", {
                  className: "title-text"
                }, header_text));
}

var BasicInfoHeaderCmp = {
  make: DriverBasicInfoCmp$BasicInfoHeaderCmp
};

function DriverBasicInfoCmp$BasicInfoContentCmp(Props) {
  var label = Props.label;
  var value = Props.value;
  return React.createElement("div", {
              className: "content-entity"
            }, React.createElement("div", {
                  className: "label"
                }, label), React.createElement("div", {
                  className: "value"
                }, value));
}

var BasicInfoContentCmp = {
  make: DriverBasicInfoCmp$BasicInfoContentCmp
};

function DriverBasicInfoCmp(Props) {
  var basic_info_list = Props.basic_info_list;
  return React.createElement("div", {
              className: "basic-info-wrapper"
            }, Belt_List.toArray(List.map((function (lead_data) {
                        return React.createElement("div", {
                                    key: lead_data.header,
                                    className: "display-info-conatiner"
                                  }, React.createElement(DriverBasicInfoCmp$BasicInfoHeaderCmp, {
                                        img_path: lead_data.img_path,
                                        header_text: lead_data.header
                                      }), React.createElement("div", {
                                        className: "content"
                                      }, Belt_List.toArray(List.map((function (param) {
                                                  var label = param[0];
                                                  return React.createElement(DriverBasicInfoCmp$BasicInfoContentCmp, {
                                                              label: label,
                                                              value: param[1],
                                                              key: label
                                                            });
                                                }), lead_data.label_value_list))));
                      }), basic_info_list)));
}

var make = DriverBasicInfoCmp;

export {
  BasicInfoHeaderCmp ,
  BasicInfoContentCmp ,
  make ,
  
}
/* react Not a pure module */
